// extracted by mini-css-extract-plugin
export default {"feed":"BeKbAa"};